import * as React from 'react';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';

export default function SelectAutoWidth(props) {

    const handleChange = (event) => {
        props.cbSelect(
            event,
            props.id,
            event.target.value
        )
    };

    return (
        <div>
            <FormControl sx={{ m: 1, minWidth: 300 }}>
                <InputLabel id="demo-simple-select-autowidth-label">{props.inputprops.label}</InputLabel>
                <Select
                    labelId="demo-simple-select-autowidth-label"
                    id="demo-simple-select-autowidth"
                    value={props.selectedValues}
                    onChange={handleChange}
                    autoWidth
                    label={props.inputprops.label}
                >
                    <MenuItem value="">
                        {/* <em>None</em> */}
                    </MenuItem>
                    {props.options.map(item => <MenuItem value={item.value}>{item.key}</MenuItem>)}
                </Select>
            </FormControl>
        </div>
    );
}
